import React from 'react';
import Nucleaire from '../../Nucleaire';

export const NukePopin = ({ nuclearScore, setNuclearScore, addLog, setShowNukePopin, setSelectedTarget, setIsTargetingMode }) => {
    return (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-3xl border-2 border-red-500/50 shadow-[0_0_50px_rgba(239,68,68,0.3)]">
                <Nucleaire
                    gameState={{
                        joueur: {
                            name: "Eurocorp",
                            leader: "Adrien Giguelay",
                            nuclear: nuclearScore
                        },
                        year: 2026
                    }}
                    onScoreIncrease={() => setNuclearScore(prev => Math.min(100, prev + 5))}
                    triggerAction={(action) => {
                        addLog(`%c[SYSTEM]%c Action nucléaire sélectionnée : ${action}`, "color: #facc15; font-weight: bold", "color: #fff");
                        setShowNukePopin(false);
                        setSelectedTarget(null);
                        if (action === 'strike' || action === 'doomsday') {
                            setIsTargetingMode(true);
                            addLog("%c[TARGETING]%c Veuillez sélectionner une cible sur la carte...", "color: #3b82f6; font-weight: bold", "color: #fff");
                        }
                    }}
                    onClose={() => setShowNukePopin(false)}
                />
            </div>
        </div>
    );
};

export const NukeModal = () => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-red-950/80 backdrop-blur-md animate-[shake_0.8s_ease-in-out_infinite]">
            <div className="bg-black border-2 border-red-500 p-12 rounded-2xl text-center shadow-[0_0_100px_rgba(239,68,68,0.5)] max-w-2xl">
                <div className="text-red-500 text-6xl mb-6">⚠️</div>
                <h1 className="text-5xl font-black text-white mb-4 tracking-tighter uppercase">Menace Nucléaire</h1>
                <p className="text-red-400 text-xl font-mono mb-8 blink">DÉTECTION D'UN LANCEMENT NON AUTORISÉ</p>
                <div className="h-2 w-full bg-red-900/50 rounded-full overflow-hidden mb-8">
                    <div className="h-full bg-red-500 w-[80%]" />
                </div>
                <button className="bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-3 px-8 rounded-lg uppercase tracking-widest transition-colors shadow-lg shadow-red-600/30">
                    INTERCEPTION EN COURS
                </button>
            </div>
        </div>
    );
};

export const QROverlay = () => {
    return (
        <div className="fixed inset-0 z-[100] bg-black/95 flex flex-col items-center justify-center backdrop-blur-xl animate-fade-in">
            <h1 className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 mb-12 tracking-tight">MERCI</h1>
            <div className="bg-white p-6 rounded-2xl shadow-[0_0_50px_rgba(59,130,246,0.3)]">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://www.giguelay.fr" alt="SCAN ME" className="w-64 h-64" />
            </div>
            <p className="text-blue-400 mt-8 text-xl font-mono">Initialisation du protocole de fin...</p>
        </div>
    );
};
